/*global boldLabelsOptions */
jQuery( document ).ready( function( $ ) {
	let allFieldsFilled = false;
	const button = $( '.single_add_to_cart_button' );

	if ( ! allFieldsFilled ) {
		button.prop( 'disabled', true );
	}

	let totalPrice = 0;

	// Initialize default values.
	setDefaultValues();

	function setDefaultValues() {
		/**
		 * Fields that should have a default value in format:
		 * 'field-name': 'label'
		 */
		const defaultValueFields = {
			'antal-rullar': 'Ospecificerat',
			'diameter-pa-karna': '76 mm (standard)',
			perforering: 'Nej',
			foradling: 'Ingen',
			'selektiv-lack': 'Ingen',
			folie: 'Ingen',
		};

		$( '.boldlabels-wc-pao-addon' ).each( function() {
			const field = jQuery( this ).find(
				'select, input[type=radio]',
			);

			if ( field.length === 0 ) {
				return true;
			}

			const name = formatKey( field.attr( 'name' ) );

			if ( name in defaultValueFields ) {
				if ( field.is( 'select' ) ) {
					const fieldValue = field.find( 'option[data-label="' + defaultValueFields[ name ] + '"]' ).val();
					field.val( fieldValue );
				}

				if ( field.is( 'input[type=radio]' ) ) {
					field.each( function() {
						if ( $( this ).data( 'label' ) === defaultValueFields[ name ] ) {
							$( this ).prop( 'checked', true );
						}
					} );
				}
			}
		} );
	}

	/**
	 * Update the variation price field.
	 */
	function updatePrice() {
		// Get variation price HTML container
		const priceHtml = $( '.summary-inner-wrapper .price' );
		const labelexpressPrice = $( 'input[name="boldlabels-price"]' );
		const updatedPrice = $( '.le-price' );
		priceHtml.remove();
		updatedPrice.remove();

		// Create new price HTML
		const newPriceHtml = `<div class="le-price"><span class="woocommerce-Price-text">${ boldLabelsOptions.translations.totalPrice }</span><span class="woocommerce-Price-amount amount" name="woocommerce-label-price">${ totalPrice }<span class="woocommerce-Price-currencySymbol">${ boldLabelsOptions.currencySymbol }</span></span></div>`;

		labelexpressPrice.val( totalPrice );
		labelexpressPrice.prop( 'value', totalPrice );
		// Replace old price with new one
		$( '.add-to-cart-wrapper' ).before( newPriceHtml );
	}

	/**
	 * Get custom product fields from the add to cart form.
	 *
	 * @return {{width: string, height: string, quantity: string}} Key/value pairs of product fields.
	 */
	function getProductFields() {
		const measurementFields = $( '.input-text.wc-pao-addon-field' );
		let measurementsObject = {};
		measurementFields.each( function() {
			const key = formatKey( $( this ).attr( 'name' ) );
			const val = $( this ).val();

			switch ( key ) {
				case 'bredd-mm':
					measurementsObject = { ...measurementsObject, ...{ width: val } };
					break;
				case 'hojd-mm':
					measurementsObject = { ...measurementsObject, ...{ height: val } };
					break;
				case 'antal':
					measurementsObject = { ...measurementsObject, ...{ cost: val } };
					break;
			}
		} );
		return measurementsObject;
	}

	/**
	 * Get product addon fields
	 *
	 * @return {Array} addonData
	 */
	function getProductAddons() {
		const allAddons = $( '.boldlabels-wc-pao-addon' );

		const addonData = {};

		allAddons.each( function() {
			const field = jQuery( this ).find(
				'select, input.input-text, input[type=radio]:checked'
			);

			if ( field.length === 0 ) {
				return true;
			}

			if ( field.prop( 'disabled' ) ) {
				return;
			}

			const value = formatKey( field.val() );
			let name = formatKey( field.attr( 'name' ) );

			name = 'pa_' + name;
			addonData[ name ] = value;
		} );

		return addonData;
	}

	/**
	 * Format our attribute keys
	 *
	 * @param {*} key
	 * @return {string} formatted key
	 */
	function formatKey( key ) {
		const pattern = /(addon-\d+-)|(-\d+$)|(-\d+(\[\])?)/g;
		const formattedKey = key.replace( pattern, '' );
		return formattedKey;
	}

	/**
	 * Control display of notice.
	 *
	 * @param {boolean} show    Display notice or not.
	 * @param {string}  message Message to display.
	 */
	function displayNotice( show, message ) {
		const addToCartWrapper = $( '.add-to-cart-wrapper' );
		const currentNotice = $( '.tipografiska-product-fields-notice' );

		if ( currentNotice.length > 0 ) {
			currentNotice.remove();
		}

		if ( show ) {
			addToCartWrapper.after(
				`<div class="tipografiska-product-fields-notice"><div class="stock out-of-stock"><p>${ message }</p></div></div>`
			);
		} else {
			currentNotice.remove();
		}
	}

	/**
	 * Check if all fields are filled when the custom inputs are changed. If they are, trigger check_variations.
	 */
	$( '.wc-pao-addon-field' ).on( 'change', function() {
		allFieldsFilled = true;

		$( '.boldlabels-wc-pao-addon' ).each( function() {
			const isHeading = $( this ).find( '.wc-pao-addon-heading' ).length > 0;
			if ( isHeading ) {
				return true;
			}

			if ( $( this ).parent().css( 'display' ) === 'none' ) {
				return true;
			}

			const isFileSelect = $( this ).find( 'input[type="file"]' ).length > 0;
			if ( isFileSelect ) {
				return true;
			}

			const isRadio = $( this ).find( '.wc-pao-addon-radio' ).length > 0;
			let fieldValue = $( this ).find( 'input, select' ).val();

			if ( isRadio ) {
				fieldValue = $( this ).find( 'input:checked' ).val();
			}

			if ( ! fieldValue && ! $( this ).find( 'input, select' ).prop( 'required' ) ) {
				allFieldsFilled = false;
			}
		} );

		// Handle when all fields have been selected and then one is unselected
		if ( ! $( this ).val() ) {
			allFieldsFilled = false;
		}

		if ( allFieldsFilled ) {
			calcPrice();
		}

		const form = document.querySelector( 'form.cart' );
		form.reportValidity();
	} );

	/**
	 * If all custom fields are filled, call the Label Express API, update the price we receive, set the add to cart button to display correctly.
	 */
	async function calcPrice() {
		$( '#product-addons-total' ).remove();

		const attributes = getProductAddons();
		const measurements = getProductFields();

		if ( allFieldsFilled ) {
			const data = {
				attributes,
				fields: {
					...measurements,
					resolution: 'standard',
					application_method: 'auto',
					package: 'thimble',
				},
			};

			button.attr( 'disabled', true );

			showLoadingOverlay();

			try {
				await $.ajax( {
					url: boldLabelsOptions.restUrl,
					type: 'POST',
					data,
					success( price ) {
						if ( price ) {
							totalPrice = price;
							updatePrice( price );
							displayNotice( false );
							button.prop( 'disabled', false );
							hideLoadingOverlay();
						}
					},
				} );
			} catch ( error ) {
				const errorMessage = error?.responseJSON?.message?.message ?? '';
				displayNotice( true, errorMessage );
				button.attr( 'disabled', true );
				hideLoadingOverlay();
			}
		}
	}

	// Handle select field where value is set by clicking img
	$( '.wc-pao-addon-image-swatch' ).on( 'click touchstart', function( e ) {
		e.preventDefault();

		const parentContainer = $( this ).closest( '.boldlabels-wc-pao-addon' );
		const selectField = parentContainer.find(
			'.wc-pao-addon-image-swatch-select'
		);

		setTimeout( function() {
			selectField.trigger( 'change' );
		}, 300 );

		parentContainer.css( 'border', 'none' );
	} );

	/**
	 * Show the loading overlay
	 */
	function showLoadingOverlay() {
		$( '.cart' ).addClass( 'loading' );

		if ( $( '.cart .loading-overlay' ).length === 0 ) {
			// If the loading overlay doesn't already exist, create and append it
			const loadingOverlay = $(
				'<div class="loading-overlay"><div class="spinner"></div></div>'
			);
			$( '.cart' ).append( loadingOverlay );
		} else {
			// If it exists, just show it
			$( '.cart .loading-overlay' ).show();
		}
	}

	/**
	 * Hide the loading overlay
	 */
	function hideLoadingOverlay() {
		$( '.cart' ).removeClass( 'loading' );
		$( '.cart .loading-overlay' ).hide();
	}
} );
